import React from 'react';

import { Icon } from '~/packages/common-frontend/components/icons';
import {
  GlobalNav,
  GlobalNavRouterLinkItem,
} from '~/packages/common-frontend/layout';

export const AnalyticsGlobalNav = ({
  isFixed = true,
}: {
  isFixed?: boolean;
}): React.ReactElement => {
  return (
    <GlobalNav isFixed={isFixed} offsetHeaderCount={1}>
      <GlobalNavRouterLinkItem
        to="/"
        label="Analytics"
        icon={<Icon icon="chart-mixed" />}
      />
    </GlobalNav>
  );
};
